var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset=ExternalLink, colour=Primary, htmlTag=img, assetKey=Content, state=Default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "open_in_new",
    d: "M5.82953 21C5.27953 21 4.8087 20.8042 4.41703 20.4125C4.02536 20.0208 3.82953 19.55 3.82953 19V5C3.82953 4.45 4.02536 3.97917 4.41703 3.5875C4.8087 3.19583 5.27953 3 5.82953 3H12.8295V5H5.82953V19H19.8295V12H21.8295V19C21.8295 19.55 21.6337 20.0208 21.242 20.4125C20.8504 20.8042 20.3795 21 19.8295 21H5.82953ZM10.5295 15.7L9.12953 14.3L18.4295 5H14.8295V3H21.8295V10H19.8295V6.4L10.5295 15.7Z",
    fill: "#0595FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/ExternalLink.827acd809c20824e0de48081f1eb7e8f.svg";
export { ForwardRef as ReactComponent };